import { Button, Col, MenuProps, Row } from 'antd';
import { Dropdown } from 'components/common/Dropdown/Dropdown';
import { Link } from 'react-router';
import { User } from 'types';
import { authPaths } from 'constants/routePaths';
import { DownOutlined } from '@ant-design/icons';
import 'styles/sass/profile.scss';
import RenderPhotos from 'components/employees/profile/RenderPhotos';
import { ThemeSelector } from 'components/common/ThemeSelector/ThemeSelector';

interface ProfileDropdownProps {
  user: User;
  impersonateMode?: boolean;
  showName?: boolean;
}

export const ProfileDropdown = ({
  user,
  impersonateMode,
  showName,
}: ProfileDropdownProps) => {
  const items: MenuProps['items'] = [
    {
      key: 'logout',
      label: (
        <Link
          className="error-txt"
          to={`${authPaths.basePath}/${authPaths.logout}`}
        >
          Salir
        </Link>
      ),
    },
  ];

  return (
    <div id="profile-dropdown">
      <Row align="middle">
        <Col xs={24}>
          <Dropdown
            menu={{ items }}
            trigger={['click']}
            disabled={impersonateMode}
            className={`${impersonateMode ? 'impersonate-mode' : ''}`}
            rootClassName="dropdown-profile"
            popupRender={(menu) => (
              <div className="profile-dropdown-panel">
                <div
                  className="profile-dropdown-appearance"
                  data-cy="profile-appearance-menu"
                  onClick={(event) => event.stopPropagation()}
                  onKeyDown={(event) => event.stopPropagation()}
                >
                  <span className="profile-dropdown-appearance-title">
                    Apariencia
                  </span>
                  <ThemeSelector className="profile-dropdown-theme-selector" />
                </div>
                {menu}
              </div>
            )}
          >
            <Button type="text">
              <Row align="middle" gutter={16} wrap={false}>
                <Col>
                  <RenderPhotos
                    employeeId={user.idEmployee}
                    lastName={user.lastName}
                    name={user.name}
                    size="sm"
                  />
                </Col>
                {showName && (
                  <Col>
                    <span className="profile-name">
                      <b>{`${user.name} ${user.lastName}`}</b>
                    </span>
                  </Col>
                )}
                {!impersonateMode && (
                  <Col>
                    <DownOutlined className="down-icon" />
                  </Col>
                )}
              </Row>
            </Button>
          </Dropdown>
        </Col>
      </Row>
    </div>
  );
};
